import './information-compte-beneficiaires.css'
import React, { useEffect, useState } from 'react'
import CompteBeneficiaires from '../../../model/entities/compte-beneficiaires'

type Props = {
    account: CompteBeneficiaires,
    selectedAccount: CompteBeneficiaires | undefined,
    onSelected: (account: CompteBeneficiaires)=> void
}

export default function InformationCompteBeneficiairesLine({account, selectedAccount, onSelected}: Props) {
    const [isSelected, setIsSelected] = useState(false)

    useEffect(()=> {
        setIsSelected(selectedAccount?.Id === account.Id)
    },[selectedAccount])
    
    return (
    <div className={`account-container ${isSelected ? 'account-selected' : 'account-not-selected'}`} onClick={() => {
        setIsSelected(!isSelected)
        onSelected(account)
        }} >
        <p>{account.Name}</p>
        <p>{account.Iban}</p>   
    </div>
    )
}
